export const link = [
  "https://www.facebook.com",
  "https://twitter.com/?lang=en",
  "https://www.instagram.com/",
  "https://www.pinterest.com/",
];
